import React, {PureComponent} from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Form, Col, InputGroup, Input, Alert} from 'reactstrap'
import classNames from 'classnames';

import { postUserBankAccount } from '../../../../actions/postalCodeAction';

import Button from '../../../Forms/Button'

class SubmitPhone extends PureComponent {
  constructor(props) {
    super(props) 
    this.state = {
      numberPhone: "",
      nama: "",
      noRek: "",
      bankName: "",
      isError: false,
      _errors: null,
      _disable: false,
    }
    this.handleChange = this.handleChange.bind(this);
    this.formValidation = this.formValidation.bind(this);
    this._process = this._process.bind(this);
  }

  formValidation() {
    let errors = {};
    if (this.state.numberPhone === '')
      errors['numberPhone'] = ['Silahkan masukkan nomor handphone Anda'] 
    if (this.state.nama === '') 
      errors['nama'] = ['Silahkan masukkan nama pemilik rekening pemilik'];
    if (this.state.noRek === '')
      errors['noRek'] = ['Silahkan masukkan nomor rekening pemilik'];
    if (this.state.bankName === '')
      errors['bankName'] = ['Silahkan masukkan nama Bank pemilik'];
    if (Object.keys(errors).length) {
      this.setState({
        _errors: errors
      })
    } 
    return errors;
  }

  errorChecker(params) {
    if (this.state._errors !== null) {
      const isErrorExist = Object.keys(this.state._errors).filter(err => err === params).length > 0;
      if (isErrorExist) {
        return (
          <Alert color="danger" isOpen={this.state._error} transition>
           { this.state._errors[`${params}`][0] }
          </Alert>
        )
      } 
    }
  }

  _inputHp = (e) => {
    this.setState({numberPhone: e.target.value.replace(/\W+|\s+|[a-zA-Z]+/g,'')})
  }

  handleChange(e) {
    const lastState = { ...this.state };
    lastState[e.target.name] = e.target.value;
    this.setState({ ...lastState });
  }

  async _process(e){
    e.preventDefault();
    const resultValidation = this.formValidation();
    if(this.state.numberPhone && Object.keys(resultValidation).length===0) {
      await this.setState({_disable: !this.state._disable, isError: false})
      await this.props.onClick(this.state.numberPhone);
      this.props.postUserBankAccount({
        account_name: this.state.nama,
        account_number: this.state.noRek,
        bank_name: this.state.bankName
      })
    }
  }

  _handleKeyPress = (event) => {
    const re = /[0-9]+/g;
      if (!re.test(event.key)) {
        event.preventDefault();
      }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.isFetch && this.props.error && this.state._disable)
      this.setState({_disable: !this.state._disable, isError: true});
    if(this.state._disable && prevProps.onUnverified)
      this.setState({_disable: false}, () => {
        this.props.postUserBankAccount({
          account_name: this.state.nama,
          account_number: this.state.noRek,
          bank_name: this.state.bankName
        })
      })
  }

  render(){
    return(
      <Form onSubmit={this._process} className="body-otp">
        <CardItem>
          <Col md={12} id="text-info">
            <div>
              <p>
                Pihak kami membutuhkan nomor handphone aktif Anda guna memudahkan
                komunikasi antara Kick Avenue dan Anda
              </p>
              <p>
                Dengan memasukkan nomor telfon Anda, artinya Anda telah menyetujui <a>Syarat dan Kententuan</a> untuk
                listing sneakers di platform Kick Avenue.
              </p>
              <p>
                Pihak Kick Avenue juga berkomitmen untuk menjaga data pribadi dan privasi Anda,
                pihak kami tidak akan membagikan data Anda kepada pihak lain yang tidak berkepentingan.
              </p>
            </div>
          </Col>
          <Col md={12} id="progress">
            <div className="progress-verify">
              <p>Nomor Handphone Aktif</p>
              <InputGroup size="lg">
                <Input type="text" name="handphone"
                  onChange={e => this._inputHp(e)}
                  onKeyPress={this._handleKeyPress}
                  value={this.state.numberPhone}
                  placeholder={"0812345678910"}
                />
              </InputGroup>
            </div>
            <Alert className={classNames("seller__registration__feedback", {'d-none' : !this.state.isError})} color="danger" isOpen={this.state.isError} transition>
              Nomor yang anda masukkan sudah terdaftar.
            </Alert>
            {
              this.errorChecker('numberPhone')
            }
          </Col>
        </CardItem>
        <CardSellerInfo>
          <Col md={12} id="progress">
            <div className="progress-verify">
              <p>Nama Pemilik Rekening</p>
              <InputGroup size="lg">
                <Input 
                  type="text" 
                  name="nama"
                  onChange={this.handleChange}
                  value={this.state.nama}
                  placeholder={"Andika Andanu"}
                />
              </InputGroup>
            </div>
            {
              this.errorChecker('nama')
            }
          </Col>
          
          <Col md={12} id="progress">
            <div className="progress-verify">
              <p>Nomor Rekening Tujuan</p>
              <InputGroup size="lg">
                <Input 
                  type="text" 
                  name="noRek"
                  onChange={this.handleChange}
                  value={this.state.noRek}
                  placeholder={"9999 9999 99"}
                />
              </InputGroup>
            </div>
            {
              this.errorChecker('noRek')
            }
            </Col>

          <Col md={12} id="progress">
            <div className="progress-verify">
              <p>Bank Tujuan</p>
              <InputGroup size="lg">
                <Input 
                  type="text" 
                  name="bankName"
                  onChange={this.handleChange}
                  value={this.state.bankName}
                  placeholder={"Contoh: Bank BCA"}
                />
              </InputGroup>
            </div>
            {
              this.errorChecker('bankName')
            }
            <Button block size="lg" className="btn-green bold" disabled={this.state._disable} buttonText="SUBMIT" loadingText="LOADING..."/>
          </Col>
        </CardSellerInfo>
      </Form>
    )
  }
}

const CardItem = styled.div`
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
`;

const CardSellerInfo = styled.div`
  padding: 10px 0;
`;

const mapDispatchToProps = dispatch => ({
  postUserBankAccount: (payload) => dispatch(postUserBankAccount(payload))
})

const mapStateToProps = state =>({
  dataPostalCode: state.dataPostalCode,
})

export default connect(mapStateToProps, mapDispatchToProps)(SubmitPhone);
